module.exports = __webpack_public_path__ + "7f25369a4b107565d9182af0aaf0ce00.svg";